module.exports = __webpack_public_path__ + "static/media/03 - Hat Close.4a9c70b1.wav";